import { render, staticRenderFns } from "./deny_email.vue?vue&type=template&id=5a710e4b&scoped=true&"
import script from "./deny_email.vue?vue&type=script&lang=js&"
export * from "./deny_email.vue?vue&type=script&lang=js&"
import style0 from "./deny_email.vue?vue&type=style&index=0&id=5a710e4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a710e4b",
  null
  
)

export default component.exports